import React from 'react';
import { PenLineIcon, WindIcon, HeartIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function StepsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="relative py-24 px-6 z-10 bg-night-800/20" data-id="element-197">
      <div ref={ref} className={`max-w-3xl mx-auto section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-198">
        <h3 className="text-4xl font-heading font-bold text-cream-100 mb-16 text-center" data-id="element-199">
          ¿Cómo Funciona?
        </h3>

        <div className="relative" data-id="element-200">
          {/* Vertical connecting line */}
          <div className="absolute left-8 md:left-12 top-10 bottom-10 w-px bg-gradient-to-b from-gold-500/50 via-lavender-500/30 to-gold-500/10 hidden md:block" data-id="element-201" />

          <div className="space-y-12" data-id="element-202">
            {/* Step 1 */}
            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10 group" data-id="element-203">
              <div className="flex-shrink-0 w-16 h-16 md:w-24 md:h-24 rounded-full glass-card flex items-center justify-center border-gold-500/30 group-hover:border-gold-400 transition-colors relative z-10 bg-night-900" data-id="element-204">
                <span className="absolute -top-2 -right-2 text-4xl font-heading font-bold text-gold-500/20" data-id="element-205">
                  1
                </span>
                <PenLineIcon className="w-8 h-8 md:w-10 md:h-10 text-gold-400" data-id="element-206" />
              </div>
              <div className="flex-1" data-id="element-207">
                <h4 className="text-2xl font-heading font-bold text-gold-400 mb-2" data-id="element-208">
                  SOLTAR
                </h4>
                <p className="text-xl text-cream-100" data-id="element-209">
                  Realizas un vaciado de datos de 3 minutos para liberar el peso
                  mental.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10 group" data-id="element-210">
              <div className="flex-shrink-0 w-16 h-16 md:w-24 md:h-24 rounded-full glass-card flex items-center justify-center border-gold-500/30 group-hover:border-gold-400 transition-colors relative z-10 bg-night-900" data-id="element-211">
                <span className="absolute -top-2 -right-2 text-4xl font-heading font-bold text-gold-500/20" data-id="element-212">
                  2
                </span>
                <WindIcon className="w-8 h-8 md:w-10 md:h-10 text-gold-400" data-id="element-213" />
              </div>
              <div className="flex-1" data-id="element-214">
                <h4 className="text-2xl font-heading font-bold text-gold-400 mb-2" data-id="element-215">
                  CALMAR
                </h4>
                <p className="text-xl text-cream-100" data-id="element-216">
                  Aplicas la Respiración Lunar para desactivar el cortisol.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10 group" data-id="element-217">
              <div className="flex-shrink-0 w-16 h-16 md:w-24 md:h-24 rounded-full glass-card flex items-center justify-center border-gold-500/30 group-hover:border-gold-400 transition-colors relative z-10 bg-night-900" data-id="element-218">
                <span className="absolute -top-2 -right-2 text-4xl font-heading font-bold text-gold-500/20" data-id="element-219">
                  3
                </span>
                <HeartIcon className="w-8 h-8 md:w-10 md:h-10 text-gold-400" data-id="element-220" />
              </div>
              <div className="flex-1" data-id="element-221">
                <h4 className="text-2xl font-heading font-bold text-gold-400 mb-2" data-id="element-222">
                  AGRADECER
                </h4>
                <p className="text-xl text-cream-100" data-id="element-223">
                  Sellas tu noche con seguridad emocional para dormir protegida.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}